import { render } from "./MaintenanceContent.vue?vue&type=template&id=aedb8ef2"
import script from "./MaintenanceContent.vue?vue&type=script&lang=js"
export * from "./MaintenanceContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__